import { ItemQuestionario } from "src/app/questionario/questao/item-questionario-base";
import { TipoItemQuestionario } from "src/app/questionario/questao/model/tipo-item-questionario.enum";


export class QuestaoArquivo extends ItemQuestionario<TipoItemQuestionario> {

  constructor(options: {} = {}) {
    super(options);
    this.questao.tipo = TipoItemQuestionario.ARQUIVO;
  }

  getMaterialIcon(): string {
    return 'attach_file';
  }

  getLabel(): string {
    return 'Arquivo';
  }
  
  isQuestaoEstruturada(): boolean {
    return false;
  }  

}